import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "../../redux/store";
import { useQueryWithPopupErrorHandling } from "../../providers/utils/hooks";
import { GET_SKUPINY } from "../../redux/actions/skupinyActions";

export const useLoadNecessaryData = () => {
  const dispatch = useDispatch();
  const { call } = useQueryWithPopupErrorHandling();
  const wasLoaded = useRef(false);
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    const loadCSSkupiny = () => {
      call(
        () => GET_SKUPINY(),
        "Získanie CS: Skupin nebolo úspešné",
        null,
        (action) => {
          dispatch(action);
        }
      );
    };

    const loadData = async () => {
      loadCSSkupiny();
    };

    if (!wasLoaded.current && auth.logged) {
      wasLoaded.current = true;
      loadData();
    }
  }, [auth]);
};
